import './History.css';

function AboutHistory() {
  const historyData = [
    { year: '2023', date: '2023.11', description: '철도차량용 HVAC제어기 개발, 공항철도 납품' },
    { year: '2023', date: '2023.10', description: '스마트팜용 전용제어기 개발' },
    { year: '2020', date: '2020.12', description: '본사이전 서울시 금천구 가산동' },
    { year: '2019', date: '2019.12', description: '배연창 듀얼 모터 컨트롤러 개발, 특허등록' },
    { year: '2017', date: '2017.08', description: '차량용 압력센서 PSI5 롬라이터 개발, KET납품' },
    { year: '2016', date: '2016.09', description: '본사이전 서울시 송파구 문정동' },
    { year: '2015', date: '2015.01', description: '재봉기의 밑실끝단 감지장치 개발, 특허등록' },
    { year: '2014', date: '2014.11', description: '동파방지용 정온전선 제어시스템 개발, 특허등록' },
    { year: '2014', date: '2014.01', description: '전동창, 배연창용 모터 컨트롤러 개발' },
    { year: '2012', date: '2012.02', description: '(주)타마 법인설립, 경기도 부천시 삼정동' },
  ];

  let prevYear = null;

  return (
    <div className="history-container">
      <div className="heat-section-title">회사연혁</div>
      <div className="history-list">
        {historyData.map((item, idx) => {
          const showYear = item.year !== prevYear;
          prevYear = item.year;

          return (
            <div key={idx} className="history-row">
              {showYear ? (
                <div className="history-year-box">{item.year}</div>
              ) : (
                <div className="history-year-placeholder" />
              )}
              <div className="history-details">
                <div className="history-date">{item.date}</div>
                <div className="history-desc">{item.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AboutHistory;
